export type PostTocItem = {
  id: string
  text: string
  level: number
}

export const usePostTocState = () => ({
  items: useState<PostTocItem[]>('blog-post-toc-items', () => []),
  floating: useState('blog-post-toc-floating', () => false),
  activeId: useState('blog-post-toc-active-id', () => '')
})
